import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../../core/hoc";
import { positions, sizes } from "../../../enums";
import Image from "../../core/image";
import Icon from "../../core/icon";
var Avatar = createComponent({
  displayName: 'Avatar',
  propTypes: {
    image: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    username: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    userHandle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    networkIcon: PropTypes.string,
    meta: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    verticalAlign: PropTypes.oneOf(positions.verticalAlign.ALL),
    size: PropTypes.oneOf([sizes.X4, sizes.X5]),
    onClick: PropTypes.func,
    onImageClick: PropTypes.func,
    onUsernameClick: PropTypes.func,
    onUserHandleClick: PropTypes.func,
    onMetaClick: PropTypes.func,
    id: PropTypes.any
  },
  defaultProps: {
    image: undefined,
    username: undefined,
    userHandle: undefined,
    networkIcon: undefined,
    meta: undefined,
    verticalAlign: positions.verticalAlign.MIDDLE,
    size: sizes.X4,
    onClick: undefined,
    onImageClick: undefined,
    onUsernameClick: undefined,
    onUserHandleClick: undefined,
    onMetaClick: undefined,
    id: null
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  handlers: {
    handleClick: function handleClick(p) {
      return function (e) {
        if (p.onClick) p.onClick(e, {
          value: p.value,
          id: p.id
        });
      };
    },
    handleImageClick: function handleImageClick(p) {
      return function (e) {
        if (p.onImageClick) {
          p.onImageClick(e, {
            value: p.value,
            id: p.id
          });
          e.stopPropagation();
        }
      };
    },
    handleUsernameClick: function handleUsernameClick(p) {
      return function (e) {
        if (p.onUsernameClick) {
          p.onUsernameClick(e, {
            value: p.value,
            id: p.id
          });
          e.stopPropagation();
        }
      };
    },
    handleUserHandleClick: function handleUserHandleClick(p) {
      return function (e) {
        if (p.onUserHandleClick) {
          p.onUserHandleClick(e, {
            value: p.value,
            id: p.id
          });
          e.stopPropagation();
        }
      };
    },
    handleMetaClick: function handleMetaClick(p) {
      return function (e) {
        if (p.onMetaClick) {
          p.onMetaClick(e, {
            value: p.value,
            id: p.id
          });
          e.stopPropagation();
        }
      };
    }
  },
  render: function render(p) {
    var _cx;

    var _avatarCx = cx('ck avatar', (_cx = {
      'avatar--inverted': p.isInverted,
      'avatar--element-clickable': p.onClick
    }, _cx["avatar--align-" + p.verticalAlign] = p.verticalAlign, _cx["avatar--size-" + p.size] = p.size, _cx));

    var _imageCx = cx('avatar-image', {
      'avatar--element-clickable': p.onImageClick
    });

    var _usernameCx = cx('avatar-content__username', {
      'avatar--element-clickable': p.onUsernameClick
    });

    var _userHandleCx = cx('avatar-content__handle', {
      'avatar--element-clickable': p.onUserHandleClick
    });

    var _metaCx = cx('avatar-content__meta', {
      'avatar--element-clickable': p.onMetaClick
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _avatarCx,
      style: p.style,
      onClick: p.handleClick
    }, /*#__PURE__*/React.createElement("div", {
      className: _imageCx,
      onClick: p.handleImageClick
    }, typeof p.image !== 'string' ? p.image : /*#__PURE__*/React.createElement(Image, {
      src: p.image,
      isBordered: false,
      size: p.size,
      isCircular: true,
      isRounded: false
    })), /*#__PURE__*/React.createElement("div", {
      className: "avatar-content"
    }, p.username ? /*#__PURE__*/React.createElement("div", {
      className: _usernameCx,
      onClick: p.handleUsernameClick
    }, p.username) : null, p.userHandle ? /*#__PURE__*/React.createElement("div", {
      className: _userHandleCx,
      onClick: p.handleUserHandleClick
    }, p.networkIcon ? /*#__PURE__*/React.createElement("div", {
      className: "avatar-content-handle__network-icon"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: p.networkIcon,
      size: sizes.X4
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "avatar-content-handle__name"
    }, p.userHandle)) : null, p.meta ? /*#__PURE__*/React.createElement("div", {
      className: _metaCx,
      onClick: p.handleMetaClick
    }, p.meta) : null));
  }
});
export var PrivateAvatar = Avatar;
export default whitelistStyles()(Avatar);
//# sourceMappingURL=index.js.map